import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { MoneyFullBRL } from '../../../../services';
import { QUERY_FILTER_BOOKSTORE, QueryFilter } from '../../../shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedBookstore } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreAverageTicketProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreAverageTicketState {
    customFilter: {
        isChart: boolean
    },
}

const BOOKSTORE_AVERAGE_TICKET = gql`
query bookstoreAverageTicket($customFilter: BookstoreCustomFilter) {
    bookstoreAverageTicket(bookstoreCustomFilter: $customFilter) {
        current_year,
		last_year
  }
}
`;

export class BookstoreAverageTicket extends React.Component<IBookstoreAverageTicketProps, IBookstoreAverageTicketState> {
    constructor(props: IBookstoreAverageTicketProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
    }
}

    public render() {
        const jsonFilter = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
          }
        };

        return (
            <Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                    
                    let dataCache = GetCacheIfExists('bookstore-data');
                    const hasNoFilterAppliedBookstore = HasNoFilterAppliedBookstore(clientC);

                    if( hasNoFilterAppliedBookstore && dataCache != null && dataCache.bookstoreAverageTicket != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={BOOKSTORE_AVERAGE_TICKET} variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, [])}>
                                {({ loading, error, data, client}) => {

                                    if ( hasNoFilterAppliedBookstore && data != null && data.bookstoreAverageTicket != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.bookstoreAverageTicket = data.bookstoreAverageTicket;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('bookstore-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        )
                    }
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Ticket Médio
                </Typography>

                {loading && <LinearProgress />}
                <Typography component="p" className="big-number">
                    {data && data.bookstoreAverageTicket && MoneyFullBRL(data.bookstoreAverageTicket[0].current_year)}
                </Typography>
                {data && data.bookstoreAverageTicket &&
                <Typography component="p" className="comparative transparent">
                    -
                </Typography>}
            </Paper>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/average-ticket/BookstoreAverageTicket.tsx